import * as React from 'react';
import { Table, Typography, Box } from '@mui/joy';

export default function StyledTable({ columns = [], rows = [], loading = false, title = null }) {
  const [sortConfig, setSortConfig] = React.useState({ key: null, direction: 'asc' });

  const handleSort = (key) => {
    setSortConfig((prev) => {
      if (prev.key === key) {
        return {
          key,
          direction: prev.direction === 'asc' ? 'desc' : 'asc',
        };
      }
      return { key, direction: 'asc' };
    });
  };

  const sortedRows = React.useMemo(() => {
    if (!sortConfig.key) return rows;
    return [...rows].sort((a, b) => {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];
      if (aValue < bValue) return sortConfig.direction === 'asc' ? -1 : 1;
      if (aValue > bValue) return sortConfig.direction === 'asc' ? 1 : -1;
      return 0;
    });
  }, [rows, sortConfig]);

  return (
    <Box>
      {title && <Typography level="h2" color="success" sx={{ mb: 2 }}>{title}</Typography>}
      {loading ? (
        <Typography>Loading...</Typography>
      ) : (
        <Table
          size="sm"
          stickyHeader
          borderAxis="bothBetween"
          hoverRow
          sx={{ minWidth: 700 }}
        >
          <thead>
            <tr>
              {columns.map((col) => (
                <th
                  key={col.key}
                  onClick={() => handleSort(col.key)}
                  style={{ cursor: 'pointer' }}
                >
                  {col.label}
                  {sortConfig.key === col.key
                    ? (sortConfig.direction === 'asc' ? ' ▲' : ' ▼')
                    : ''}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {sortedRows.length > 0 ? (
              sortedRows.map((row, idx) => (
                <tr key={idx} style={row._rowSx || {}}>
                  {columns.map((col) => (
                    <td key={col.key}>{row[col.key]}</td>
                  ))}
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={columns.length}>
                  <Typography textAlign="center">No records found.</Typography>
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      )}
    </Box>
  );
}